import { authReducer } from './authReducer';
import { authActions } from './authActions';
import { authSagas } from './authSagas';
export default {
    reducer: authReducer,
    actions: authActions,
    sagas: authSagas,
};
